export default function Agreement() {
    return (
        <div className="page" style={{padding: '0 10px'}}>
                <h3>快背中医用户协议</h3>
                <p></p>
                <p>更新日期：2024年6月10日</p>
                <p>生效日期：2024年6月10日</p>
                <p><b>免责声明</b></p>
                <p>1.用户明确同意其使用快背中医应用所存在的风险将完全由其自己承担;因其使用本服务而产生的一切后果也由其自己承担，平台（以下简称“平台”或“我们”）作为本应用的运营者，对用户不承担任何责任。</p>
                <p>2.平台不担保网络服务一定能满足用户的要求，也不担保网络服务不会中断，对网络服务的及时性、安全性、准确性也都不作担保。</p>
                <p><b>用户注册协议</b></p>
                <p>《用户注册协议》 (以下简称“本协议”)
                        是您(或称“用户”，指登录、使用、浏览本服务的个人或组织)与平台之间关于网络运营服务、医疗服务等所订立的协议。本协议中所列条款内容最终所有权、解释权归平台所有,平台完全遵守并执行本协议所列条款及操作规则;平台在此特别提醒用户认真阅读、充分理解本协议中各条款。请您审慎阅读并选择接受或不接受本协议(未成年人应在法定监护人陪同下阅读)。同时只有您在完全接受本协议、完成注册申请程序且通过申请，才能成为本平台的用户</p>
                <p><b>协议的适用范围</b></p>
                <p>本协议适用范围包括: 在本平台所进行的一切相关服务和工具。</p>
                <p><b>服务对象</b></p>
                <p>本平台的服务内容 (以下简称“服务”)
                        仅提供给接受本协议规定，并具有法人资格的单位或具有完全民事行为能力的个人使用(未成年人应在法定监护人陪同下使用)，同时，平台在认为有合理理由的情况下，有权随时决定拒绝向任何个人或单位提供服务。</p>
                <p><b>定义</b></p>
                <p>1.服务:指由平台所有、控制和运营的，可在电脑、移动终端等各种设备上运行的软件、公众号、小程序、内容和数据资料。包括但不限于文本、图片、音频、视频、软件等信息和资料。</p>
                <p>2.用户:指在平台客户端软件、公众号、小程序上发布消息或接受服务的用户。</p>
                <p><b>用户同意</b></p>
                <p>1.您保证具备履行本协议项下义务和享有本协议项下权益的资格和能力。您声明并保证尊重本平台以及其他用户的合法权益，不贬低本平台的商誉以及产品和服务的声誉。</p>
                <p>2.您声明并保证在使用本平台的产品和服务时不会违反任何法律、法规、条例或规章(包括但不限于关于规范互联网站、互联网信息、不正当竞争的法律、法规、条例或规章)或危害网络安全、损害第三方合法权益之行为。</p>
                <p>3.平台保留随时变更、中断或终止部分或全部网络服务的权利。</p>
                <p>4.您声明并保证不会删除、隐匿或改变本平台的产品和服务中显示或其中包含的任何知识产权或其他所有权声明;不会以任何方式干扰或企图干扰本平台、及其产品和服务的正常运行，或者制作、发布、传播可能造成前述后果的工具、方法等。</p>
                <p>5.您声明并保证您使用本平台产品和服务以及第三方产品和服务，和/或通过本平台的产品和服务进行发布拥有合法权利内容的时候，应遵循诚实信用原则，尊重社会公德，不损害社会公共利益。您应保证:</p>
                <p>(1)您不会发布、传播、提供含有任何政治、宗教迷信、淫秽、色情、不道德、欺诈、诽谤、侮辱等内容。您发布的内容不会侵犯任何法律法规或第三方的任何权利，如因您发布的内容导致本平台或其他第三方遭受损失的，您应承担全部责任。</p>
                <p>(2)不得利用本平台从事洗钱、窃取商业秘密、窃取个人信息等违法犯罪活动。</p>
                <p>(3)不得教唆他人从事本条所禁止的行为。</p>
                <p>(4)不得利用在本平台注册的账户进行牟利性经营活动。</p>
                <p>(5)您的行为真实、合法、准确、完整。您不得损害本平台和他人的合法权益，不得妨碍本平台和第三方行使权益。</p>
                <p>(6)您就您发布的内容(若其中涉及的第三方知识产权，您应拥有合法的授权和转授权)，在此不可撤销的授予平台全球范围内的免费的、无期限的、非排他的、可转让和可分/转授权的使用许可。本平台及与本平台合作的第三方可以不受限制地在平台的产品和服务或合作的产品和服务中免费使用、传播，并供用户以浏览、下载等方式使用您发布的内容。</p>
                <p>6.您明确理解并同意，您通过本平台使用第三方的产品和服务时，应仔细阅读本平台上第三方产品和服务的内容、谨慎选择并与第三方单独签署相应的使用协议以保障您个人的合法权益，并严格按照协议的约定履行。如因您使用第三方的产品和服务弓发的任何纠纷，您应自行解决并承担由此引发的全部责任，平台对此不承担任何责任。</p>
                <p>7.您同意，平台拥有通过邮件、短信电话等形式，向在本平台注册、购买的用户发送订单信息、促销活动等告知信息的权利。</p>
                <p>8.您必须自行准备如下设备和承担如下开支:</p>
                <p>a.上网设备，包括并不限于电脑或者其他上网终端、调制解调器及其他必备的上网装置;</p>
                <p>b.上网开支，包括并不限于网络接入费、上网设备租用费、手机流量费等。</p>
                <p>c.您声明并同意平台可指定第三方成为本协议的受益人，并有权直接履行和享受本协议项下权利。</p>
                <p><b>服务内容及说明</b></p>
                <p>1.本平台服务的具体内容由平台根据实际情况提供，例如在线检索等。平台保留随时变更、中断或终止部分或全部服务的权利。</p>
                <p>2.本平台在提供网络服务时，可能会对部分网络服务(例如收费科别)的用户收取一定的费用。在此情况下，本平台会在相关页面上做明确的提示。如用户拒绝支付该等费用，则不能使用相关的网络服务。</p>
                <p>3.本平台提供的中药知识库、中医知识库等内容服务均来自中医药相关方面的文献，所刊列的各类文章、图片、资料均仅代表作者或信息提供者的观点，即为本平台成员原创或整理，版权归作者与本平台共同所有。若作者有版权声明的或文章从其他网站转载而附带有原所有站的版权声明者，其版权归属以附带声明为准。本平台仅为提供更多信息而发布，仅供参考学习，其内容既不代表本平台的观点，也不构成任何学术建议。</p>
                <p>4.本平台所提供的各种信息意在辅助医者诊疗或用药学习;非医者因参考本平台诊疗、用药信息自行治疗或用药出现的任何后果，本平台不负任何法律责任。即使为医者，在使用本平台辅助用药剂量时，也要注意到红字提示的超中国药典剂量，如出现问题，本平台将不负任何法律责任。</p>
                <p>5.为了您能通过耳机、锁屏界面或蓝牙设备控制音频播放，本平台需要使用后台音频服务。此功能仅在您使用应用时或按下次媒体键时唤醒播放服务，我们不会在无合理场景下自动启动。</p>
                <p><b>内容所有权</b></p>
                <p>1.平台提供的网络服务内容受版权、商标和其它财产所有权法律的保护。</p>
                <p>2.用户只有在获得平台授权之后才能使用这些内容，而不能擅自复制、再造这些内容、或创造与内容有关的派生产品。</p>
                <p><b>违约和赔偿</b></p>
                <p>如您损害本平台的合法权益，或您导致本平台遭受任何来自第三方的纠纷、诉讼、索赔要求等，您须向平台赔偿相应的损失，并需对因您的行为产生的一切后果负全部法律责任。</p>
                <p><b>服务中止或终止</b></p>
                <p>1.下述任一原因发生，无需提前通知，本平台有权单方面决定是否随时中止或终止服务，您同意并接受平台的处理决定:</p>
                <p>a.非因本平台主观故意的过错，您无法使用服务;</p>
                <p>b.因不可抗力原因，服务中止或终止;</p>
                <p>c.本平台无法预见和控制的原因，服务中止或终止;</p>
                <p>d.本平台停止运营某特定产品和服务;</p>
                <p>e.本平台认为实际情形不再适宜继续履行本协议;</p>
                <p>f.本协议约定的其他情况。</p>
                <p>2.不论本平台与您之间的服务因任何原因以任何方式终止，您同意并接受:</p>
                <p>a.平台有权保存或不保存您发布的内容及其他相关数据和信息;</p>
                <p>b.平台有权保存或不保存您账户和账户信息;</p>
                <p>c.在服务终止之前，您和本平台、平台或其他第三方的交易尚未完成的，例如尚未下载完毕或尚未付款，平台有权在中断、终止服务的后时删除此项交易信息;</p>
                <p>d.服务终止之前，您和本平台、平台或其他第三方的交易已完成的，平台有权在中断.终止服务的同时删除此项交易信息。</p>
                <p>e.如无论因任何原因终止的，在终止之前，您应自行处理好数据、信息的备份以及与本平台、任意第三方间的相关事项的处理等，否则，由此产生的您与任意第三方之间的纠纷等问题由您自行负责解决，并单独承担完全责任。由此造成本平台损失的，您应负责赔偿。</p>
                <p>3.您必须完全独立地承担，您在服务终止前实施的违法或违约行为所导致的任何赔偿和责任。</p>
                <p>4.本平台未行使本协议的任何权利或规定，不构成对前述权利之放弃。</p>
                <p>5.本条不影响本平台按照本协议规定追究您的违约责任。</p>
                <p><b>不可抗力</b></p>
                <p>1.不可抗力是指不能预见、不能克服并不能避免且对一方或双方造成重大影响的客观事件，包括但不限于自然灾害如洪水、地震、癌疫流行和风暴等以及社会事件如战争、动乱、法规政策颁布和修改行政行为、政府决定等。</p>
                <p>2.出现上述情况时，平台将努力在第一时间与相关单位配合，及时进行修复，若由此给您造成损失的，您同意放弃追究本平台的责任。</p>
                <p><b>免责条款</b></p>
                <p>1.除非另有明确的书面说明，本平台及其所包含的或以其它方式通过本平台提供给您的全部信息、内容、材料、产品(包括软件)和服务，均是在“按现状”和“按现有”的基础上提供的。除非另有明确的书面说明，平台不对本平台的运营及其包含在本平台上的信息、内容、材料、产品(包括软件)或服务作任何形式的、明示或默示的声明或担保
                        （根据中华人民共和国法律另有规定的以外）。</p>
                <p>2.本平台所承载的内容(文、图、视频音频)均为传播有益健康资讯目的，不对其真实性、科学性、准确性、严肃性做任何形式保证。平台所有信息仅供参考，不做个别诊断、用药和使用的根据。</p>
                <p>3.平台拒绝回复平台功能使用之外的咨询问题，包括但不限于如下情况:</p>
                <p>a.医疗健康类问题;</p>
                <p>b.医疗司法举证或询证问题;</p>
                <p>c.胎儿性别鉴定问题;</p>
                <p>d.有危害他人/自己可能的问题;</p>
                <p>e.追问他人个人信息的问题;</p>
                <p>f.故意挑逗、侮辱的提问;</p>
                <p>g.以及其他平台认为不适当的问题。</p>
                <p>4.您应遵守法律法规及本协议的约定及承诺，否则被行政机关、司法执法机构或第三方调查、举报,或被本平台、平台自行检查时发现的，及或因此损害本平台、平台及或第三方的权益的，您应当负责解决并承担全部法律责任;并且平台有权随时在不通知您的前提下按照如下方案予以处理，而不承担任何责任:</p>
                <p>a.不予发布、屏蔽或删除您发布的全部或部分的内容、数据和信息;</p>
                <p>b.封禁或删除您的账户，中/终止提供产品和服务;</p>
                <p>c.将您的行为对外予以公告;</p>
                <p>d.追究您的法律责任;</p>
                <p>e.其他平台认为适合的处理措施。</p>
                <p>5.本平台不因下述任一情况而可能导致的任何损害赔偿承担责任，包括但不限于财产、收益、数据资料等方面的损失或其它无形损失:</p>
                <p>a.因不可抗力导致本平台系统障碍不能正常运作;</p>
                <p>b.由于黑客攻击、电信部门技术调整或故障、系统维护等原因而造成的平台服务中断或者延迟。</p>
                <p>6.鉴于网络服务的特殊性，本平台有权在无需通知您的情况下根据本平台、平台及其关联企业的整体运营情况或相关运营规范、规则等，可以随时终止服务或停止运营。若由此给您造成损失的，您同意放弃追究平台的责任。对于此类情形下可能造成的风险，请您充分了解并同意自行承担由此可能造成的一切不利后果和损失。</p>
                <p>7.在法律允许的最大限度内，平台明确表示不对其产品和服务做出任何明示、暗示和强制的担保，包括但不限于安全性可靠性、稳定性、及时性、适销性、针对特定用途的适用性以及不侵犯所有权或其他权益的担保。</p>
                <p><b>协议更新及用户关注义务</b></p>
                <p>根据国家法律法规变化及网络运营需要，平台有权在不另行通知的情况下对本协议条款不时地进行修改，修改后的协议即时生效并适用。您可随时登录查阅最新协议;您有义务不时关注并阅读最新版的协议及客户端公告。如您不同意更新后的协议，您可以且应立即停止接受本平台客户端提供的服务;如您继续使用本平台提供的服务，即视为同意更新后的协议。平台建议您在使用本平台之前阅读本协议及本平台的公告。如果本协议中任何一条被视为废止、无效或因任何理由不可执行，该条应视为可分的且并不影响任何其余条款的有效性和可执行性。</p>
                <p><b>法律管辖和适用</b></p>
                <p>本协议的订立、执行和解释及争议的解决均应适用在中华人民共和国大陆地区适用之有效法律(但不包括其冲突法规则)。如发生本协议与适用之法律相抵触时，则这些条款将完全按法律规定重新解释，而其它有效条款继续有效。如缔约方就本协议内容或其执行发生任何争议，双方应尽力友好协商解决。</p>
                <p><b>通知和送达</b></p>
                <p>本协议项下所有的通知均可通过重要页面公告、电子邮件或常规的信件传送等方式进行;该等通知于发送之日视为已送达收件人。</p>
                <p><b>其他规定</b></p>
                <p>1.本协议构成双方对本协议之约定事项及其他有关事宜的完整协议，除本协议规定的之外，未赋予本协议各方其他权利。</p>
                <p>2.如本协议中的任何条款无论因何种原因完全或部分无效或不具有执行力，本协议的其余条款仍应有效并且有约束力。</p>
                <p>3.本协议中的标题仅为方便而设，在解释本协议时应被忽略。</p>
                <p>开发者名称：<b>重庆沃可达科技有限公司</b></p>
        </div>
    );
}
